export default "__VITE_ASSET__8030017c__"